import { config } from '@/config/environment';
import { ClientAnalyticsEventType } from './constants';

export const track = (event: ClientAnalyticsEventType, properties: Record<string, string>) => {
  if (
    config.platformMode !== 'archive' &&
    config.segmentKey &&
    typeof (window as any).analytics !== 'undefined' &&
    event
  ) {
    return (window as any).analytics.track(event, properties);
  }
};
